import {
  AUTH_USER_SUCCESS,
  UNAUTH_USER,
  FULL_SYNC_SUCCESS,
  FORCE_FULL_SYNC,
  REFRESH_USER_TOKEN,
  AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_REQUEST,
  AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_SUCCESS,
  AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_FAILURE,
  AUTH_ACCEPT_AF_TERMS,
  PART_A_GET_AUTH_TOKEN_SUCCESS,
  PART_A_CLEAR_TOKEN,
  SET_BASE_URL,
  OKTA_AUTH_SUCCESS,
  SET_MIL_ENV,
} from '../actions/actionTypes';

/* ----------------------------------------------- */
/* ----------------- USER ------------------------ */
/* ----------------------------------------------- */

let USER_INITIAL_STATE = {
  oktaAuthToken: null,
  oktaNonce: null,
  token: null,
  partAToken: null,
  partAAuthed: false,
  fullSync: false,
  userId: null,
  firebaseRegistrationTokenSending: false,
  firebaseRegistrationLastToken: null,
  baseUrl: null,
  milEnv: false,
};

function userReducer(state = USER_INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MIL_ENV:
      return {
        ...state,
        milEnv: action.payload,
      };
    case OKTA_AUTH_SUCCESS:
      // this is used to set the okta auth token in the userReducer
      // so that we can use it in the app
      return {
        ...state,
        oktaAuthToken: action.payload.token,
        oktaNonce: action.payload.nonce,
      };
    // in dev store the token in redux so that we can reload the page to test ui changes without
    // being logged out. but IRL we're not storing the token in redux for security reasons
    // the flag partAAuthed is used to signal to the UI if/when the user receives a
    // 401 response at any time (which will clear the userReducer)
    case PART_A_CLEAR_TOKEN:
      return !__DEV__
        ? {
            ...state,
            partAAuthed: false,
          }
        : {
            ...state,
            partAToken: null,
            partAAuthed: false,
          };
    case PART_A_GET_AUTH_TOKEN_SUCCESS:
      return !__DEV__
        ? {
            ...state,
            partAAuthed: true,
          }
        : {
            ...state,
            partAToken: action.payload,
            partAAuthed: true,
          };
    case AUTH_USER_SUCCESS:
      if (!action.payload) return state;
      const employers = action.payload.employers || {};
      const af =
        action.payload.isMilitary ||
        action.payload.isAFInvite ||
        !!Object.keys(employers)
          .map((k) => employers[k])
          .find((e) => e.uiConfig?.type === 'airforce');
      // const af = false;
      return {
        ...state,
        token: action.payload.token,
        userId: action.payload.userId,
        pendingTermsAccept: af && !action.payload.afTermsAlreadyAccepted,
        af,
      };
    case AUTH_ACCEPT_AF_TERMS:
      return {
        ...state,
        pendingTermsAccept: false,
      };
    case REFRESH_USER_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case UNAUTH_USER:
      if (action.payload?.preserveOktaToken) {
        return {
          ...USER_INITIAL_STATE,
          oktaAuthToken: state.oktaAuthToken,
          oktaNonce: state.oktaNonce,
        };
      }
      return {
        ...USER_INITIAL_STATE,
      };
    // Should we do Full sync for web but not for native here???
    case FULL_SYNC_SUCCESS:
      return { ...state, fullSync: true };
    case FORCE_FULL_SYNC:
      return {
        ...state,
        fullSync: false,
      };
    case AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_REQUEST:
      return {
        ...state,
        firebaseRegistrationTokenSending: true,
        firebaseRegistrationLastToken: null,
      };
    case AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_SUCCESS:
      return {
        ...state,
        firebaseRegistrationTokenSending: false,
        firebaseRegistrationLastToken: action.payload,
      };
    case AUTH_SAVE_FIREBASE_REGISTRATION_TOKEN_FAILURE:
      return {
        ...state,
        firebaseRegistrationTokenSending: false,
        firebaseRegistrationLastToken: null,
      };
    case SET_BASE_URL:
      return {
        ...state,
        baseUrl: action.payload,
      };
    default:
      return state;
  }
  return state;
}

export default userReducer;
